import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _defineProperty from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import Vue from 'vue';
import Clipboard from 'clipboard';
function clipboardSuccess(msg) {
  Vue.prototype.$message({
    message: msg || 'Copy successfully',
    type: 'success',
    duration: 1500
  });
}
function clipboardError(msg) {
  Vue.prototype.$message({
    message: msg || 'Copy failed',
    type: 'error'
  });
}

/**
 * @description 复制图片
 * @param  {number} width
 * @param  {number} height
 * ！！navigator.clipboardundefined原因是因为navigator.clipboard对象只能在安全网络环境中才能使用，也就是，localhost中，或者https中才能正常使用，直接用ip地址访问时不可以的呢
 * 也就是上uat才能复制！！
 */
export function copyImg(width, height, src) {
  var _window = window,
    ClipboardItem = _window.ClipboardItem;
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var img = document.createElement('img');
  canvas.width = width;
  canvas.height = height;
  img.src = src;
  img.onload = function (e) {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.drawImage(img, 0, 0);
    // 将canvas转为blob
    canvas.toBlob(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(blob) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return navigator.clipboard.write([new ClipboardItem(_defineProperty({}, blob.type, blob))]).then(function () {
                clipboardSuccess('复制成功!');
              }, function () {
                clipboardError('复制失败!');
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  };
  img.onerror = function (e) {
    console.error(e);
  };
}
export default function handleClipboard(_text, event, msg) {
  var clipboard = new Clipboard(event.target, {
    text: function text() {
      return _text;
    }
  });
  clipboard.on('success', function (e) {
    clipboardSuccess(msg);
    clipboard.off('error');
    clipboard.off('success');
    clipboard.destroy();
  });
  clipboard.on('error', function (e) {
    clipboardError();
    clipboard.off('error');
    clipboard.off('success');
    clipboard.destroy();
  });
  clipboard.onClick(event);
}